import {FC} from 'react'

const Error500: FC = () => {
  return (
    <>
      <h1 className='fw-bolder fs-4x text-gray-700 mb-10'>System Error</h1>

      <div className='fw-bold fs-3 text-gray-400 mb-15'>
        Oops! Hmm, something didn’t quite work as expected. Please refresh and try again, or reach out if you need a hand.!
      </div>
    </>
  )
}

export {Error500}
